import * as React from 'react';
import styled from 'styled-components';

import { MarkdownPreview } from 'components/common/MarkdownEditor';

const StyledCode = styled.code<{ $disabled?: boolean }>`
  background-color: transparent;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

  &:hover {
    color: ${({ theme, $disabled }) => ($disabled ? theme.colors.text.secondary : theme.colors.text.primary)};
  }
`;

const MarkdownWrapper = styled.div`
  cursor: pointer;
`;

function DescriptionCell({ mdValue }: { mdValue: string }) {
  const [showFormatted, setShowFormatted] = React.useState<boolean>(false);
  const stringMaxLength = 100;

  if (!mdValue)
    return (
      <StyledCode $disabled>
        <i>No description set</i>
      </StyledCode>
    );

  return showFormatted ? (
    <MarkdownWrapper onClick={() => setShowFormatted(false)}>
      <MarkdownPreview show maxHeight={500} noBackground noBorder value={mdValue} noPadding />
    </MarkdownWrapper>
  ) : (
    <StyledCode onClick={() => setShowFormatted(true)}>
      {`${mdValue.slice(0, stringMaxLength)}${mdValue.length >= stringMaxLength ? '...' : ''}`}
    </StyledCode>
  );
}

export default DescriptionCell;
